export default __webpack_public_path__ + "static/media/winter.17179ec9.jpg";